import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function DemoBookWrapper() {

  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location]);
  
    return (
        <div className="h-screen ">
          <iframe
            src={`https://calendly.com/arpita-fai/schedule-a-demo`}
            title="Company Documents"
            loading="eager"
            width="100%"
            height="90%"      
          ></iframe>
        </div>
      );
}
